import { graphToolLabel } from '../node-graph/tool-labels.js';
/** Which responder answers a new thread: a graph, a v2 agent, or none. */
export const GRAPH_SESSION_PICK = 'graph-session-pick';
/** An edge held and the session moved to another node. */
export const GRAPH_NODE_MOVE = 'graph-node-move';
/** A signal's reading changed on the node the session is on. */
export const GRAPH_SIGNAL_RESOLVED = 'graph-signal-resolved';
/** A tool ran for the turn, with the request it was given and what it returned. */
export const GRAPH_TOOL_CALL = 'graph-tool-call';
function text(value) {
    return typeof value === 'string' && value.length > 0 ? value : null;
}
function count(value) {
    return typeof value === 'number' && Number.isFinite(value) ? value : null;
}
function strings(value) {
    return Array.isArray(value)
        ? value.filter((item) => typeof item === 'string')
        : [];
}
/** How a signal reading reads: unread before the first judgment, then yes or no. */
export function signalReadingLabel(value) {
    if (value === true)
        return 'yes';
    if (value === false)
        return 'no';
    return 'unread';
}
function plural(n, word) {
    return `${n} ${word}${n === 1 ? '' : 's'}`;
}
export const GRAPH_DECISION_SUMMARIES = {
    [GRAPH_SESSION_PICK]: (inputs, outcome) => {
        const graphName = text(outcome?.graphName);
        if (graphName) {
            const candidates = strings(inputs?.candidateGraphIds).length;
            const channel = text(inputs?.channel) ?? 'the channel';
            return `Graph "${graphName}" chosen over ${plural(candidates, 'candidate')} on ${channel}`;
        }
        const agent = text(outcome?.agentName) ?? text(outcome?.agentId);
        const unstartable = text(outcome?.unstartableGraphId);
        if (unstartable) {
            return agent
                ? `v2 agent ${agent}; the active graph cannot start`
                : 'No agent, and the active graph cannot start';
        }
        return agent ? `v2 agent ${agent} (no graph)` : 'No graph and no agent';
    },
    [GRAPH_NODE_MOVE]: (inputs, outcome) => {
        const from = text(inputs?.fromTitle) ?? 'Start';
        const to = text(outcome?.toTitle) ?? 'unknown node';
        const event = text(inputs?.event);
        const move = event ? `${from} → ${to}, on ${event}` : `${from} → ${to}`;
        return outcome?.ended === true ? `${move}; session ended` : move;
    },
    [GRAPH_SIGNAL_RESOLVED]: (inputs, outcome) => {
        const signal = text(inputs?.signal) ?? 'signal';
        return `${signal}: ${signalReadingLabel(outcome?.previous)} → ${signalReadingLabel(outcome?.typed)}`;
    },
    [GRAPH_TOOL_CALL]: (inputs, outcome) => {
        const label = graphToolLabel(inputs?.tool);
        if (label === 'Language') {
            return `Language switched to ${text(outcome?.language) ?? 'unknown'}`;
        }
        const matched = count(outcome?.matched);
        const considered = count(outcome?.considered);
        const shown = strings(outcome?.shown);
        if (matched === null || considered === null) {
            const summary = text(outcome?.summary);
            return summary && !summary.startsWith('{')
                ? `${label}: ${summary}`
                : `${label} ran`;
        }
        const where = shown.length > 0 ? ` (${shown.join(', ')})` : '';
        return `${label}: ${matched} of ${considered} matched, ${shown.length} shown${where}`;
    },
};
export function isGraphDecisionType(value) {
    return (value === GRAPH_SESSION_PICK ||
        value === GRAPH_NODE_MOVE ||
        value === GRAPH_SIGNAL_RESOLVED ||
        value === GRAPH_TOOL_CALL);
}
//# sourceMappingURL=graph-session.js.map